import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Wallet } from '@app/@shared/models/wallet.model';
import { CustomerService } from '@app/@shared/services/customer.service';
import { WalletService } from '@app/@shared/services/wallet.service';
import { Credentials } from '@app/auth/credentials.service';

import { AlertController, NavController, PopoverController } from '@ionic/angular';
import { Timestamp } from 'firebase/firestore';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-wallet-card',
  templateUrl: './wallet-card.component.html',
  styleUrls: ['./wallet-card.component.scss'],
})
export class WalletCardComponent implements OnInit, OnDestroy {
  @Input() balance = 0;
  isPopover = false;
  @Input() isLoading = false;
  @Input() isAward = false;
  @Input() isBonus = false;
  @Input() email = '';
  @Input() isAllowedCountry = false;
  @Input() wallets: Wallet[] = [];
  @Input() credentials: Credentials | null = null;

  walletS?: WalletService;
  subscriptions: Subscription[] = [];

  walletsSorted = false;
  constructor(
    private navCtrl: NavController,
    private alertController: AlertController,
    private popoverCtrl: PopoverController,
    private customerS: CustomerService
  ) {}

  ngOnInit(): void {
    if (this.isPopover && this.walletS) {
      this.subscriptions.push(this.walletS.balanceChange.subscribe((b) => (this.balance = b)));
    }
  }

  ngOnDestroy(): void {
    // Limpiar todas las suscripciones
    this.subscriptions.forEach((s) => {
      if (s && !s.closed) {
        s.unsubscribe();
      }
    });
    // Limpiar el array
    this.subscriptions = [];
  }

  sortWallets() {
    if (this.walletsSorted) return;
    this.wallets = this.wallets
      .map((w) => {
        if (w.walletName === 'loteria') {
          (w as any).order = 1;
        }

        if (w.walletName === 'award') {
          (w as any).order = 2;
        }

        if (w.walletName === 'award-casino') {
          (w as any).order = 3;
        }

        return w;
      })
      .sort((a, b) => (a as any).order - (b as any).order);

    this.walletsSorted = true;
  }

  async openAddFundsOrTransferModal() {
    const id = this.isAward ? 'openPayout' : 'openFunds';

    if (this.isAward) {
      document.getElementById(id)?.click();
      if (this.isPopover) this.popoverCtrl.dismiss();
    } else {
      if (this.credentials?.customer.exclusion) {
        const customer = this.credentials?.customer;
        const timeEx = customer.timeEx;
        const periodEx = customer.periodEx as Timestamp; // Firestore Timestamp

        let formattedDate = '';

        const dateObj = periodEx.toDate();
        const today = new Date(); // Fecha actual

        formattedDate = dateObj.toLocaleDateString('es-ES', {
          day: '2-digit',
          month: 'long',
          year: 'numeric',
        });

        if (today < dateObj) {
          // Mensaje dinámico según timeEx
          let message = '';
          if (timeEx === '0') {
            message =
              'Tu cuenta está actualmente en autoexclusión y no puedes cargar saldo por tiempo indefinido. Si quieres reactivar tu acceso contacta a atencion_clientes@cmillonario.mx.';
          } else {
            message = `Tu cuenta está actualmente en autoexclusión y no puedes cargar saldo por ${timeEx} meses, hasta el día ${formattedDate}.`;
          }

          const alert = await this.alertController.create({
            header: 'Autoexclusión activa',
            message,
            buttons: [
              {
                text: 'Aceptar',
                role: 'cancel',
              },
            ],
            cssClass: 'alert',
          });

          await alert.present();
        } else {
          await this.customerS.update(this.credentials.id, { exclusion: false });
          this.credentials.customer.exclusion = false;
          document.getElementById(id)?.click();
          if (this.isPopover) this.popoverCtrl.dismiss();
        }
      } else {
        document.getElementById(id)?.click();
        if (this.isPopover) this.popoverCtrl.dismiss();
      }
    }
  }

  async goTo(path: string[]) {
    if (!this.isPopover) return;
    await this.navCtrl.navigateForward(path);
    this.popoverCtrl.dismiss();
  }

  async clickDetail() {
    if (this.isPopover) {
      this.goTo(['/', 'wallet']);
      // return;
    }

    // if (!this.wallets.length) return;

    // const modal = await this.modalCtrl.create({
    //   component: DetailsComponent,
    //   componentProps: {
    //     wallets: this.wallets
    //       .map((w) => {
    //         if (w.walletName === 'loteria') {
    //           (w as any).order = 1;
    //         }

    //         if (w.walletName === 'award') {
    //           (w as any).order = 2;
    //         }

    //         if (w.walletName === 'award-casino') {
    //           (w as any).order = 3;
    //         }

    //         return w;
    //       })
    //       .sort((a, b) => (a as any).order - (b as any).order),
    //     credentials: this.credentials,
    //   },
    // });

    // await modal.present();
  }
}
